import createDataReducer from "../../helpers/createDataReducer";
import deltas from "../../actions/deltas";

const {
    SET_STATUSES,
} = deltas.actionTypes;

export default createDataReducer(
    SET_STATUSES,
);
